import { render, staticRenderFns } from "./dictionaryDetailModal01.vue?vue&type=template&id=7bfaa029"
import script from "./dictionaryDetailModal01.vue?vue&type=script&lang=js"
export * from "./dictionaryDetailModal01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports